import { gql } from '@apollo/client';

// ==================== QUERIES ====================

export const GET_BUSINESS_HOURS_CONFIG = gql`
  query GetBusinessHoursConfig {
    getBusinessHoursConfig {
      id
      startHour
      startMinute
      endHour
      endMinute
      totalHours
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
      createdAt
      updatedAt
    }
  }
`;

export const GET_HOURLY_SALES = gql`
  query GetHourlySales($date: DateTime!) {
    getHourlySales(date: $date) {
      id
      date
      hour
      salesAmount
      salesCount
      targetAmount
      targetPerHour
      isBehind
      isOnTrack
      isAhead
      percentage
      createdAt
      updatedAt
    }
  }
`;

export const GET_HOURLY_STATUS = gql`
  query GetHourlyStatus($date: DateTime!, $dailyTarget: Float!) {
    getHourlyStatus(date: $date, dailyTarget: $dailyTarget) {
      hour
      # Modo Especial POS
      salesAmount
      salesCount
      targetPerHour
      adaptiveTargetPerHour
      percentage
      adaptivePercentage
      isBehind
      isOnTrack
      isAhead
      isPastHour
      isCurrentHour
      # Control por Impuesto (Facturación Electrónica)
      electronicSalesAmount
      electronicSalesCount
      electronicTaxAmount
      electronicTargetPerHour
      electronicAdaptiveTarget
      electronicPercentage
      electronicAdaptivePercentage
      electronicIsBehind
      electronicIsOnTrack
      electronicIsAhead
    }
  }
`;

export const GET_DAILY_SUMMARY = gql`
  query GetDailySummary($date: DateTime!, $dailyTarget: Float!) {
    getDailySummary(date: $date, dailyTarget: $dailyTarget) {
      totalSales
      totalCount
      targetPerHour
      hoursCompleted
      hoursBehind
      hoursOnTrack
      hoursAhead
      overallPercentage
    }
  }
`;

// ==================== MUTATIONS ====================

export const UPDATE_BUSINESS_HOURS_CONFIG = gql`
  mutation UpdateBusinessHoursConfig($input: UpdateBusinessHoursInput!) {
    updateBusinessHoursConfig(input: $input) {
      id
      startHour
      startMinute
      endHour
      endMinute
      totalHours
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_HOURLY_SALES = gql`
  mutation UpdateHourlySales(
    $date: DateTime!
    $hour: Int!
    $salesAmount: Float!
    $salesCount: Int!
    $dailyTarget: Float!
  ) {
    updateHourlySales(
      date: $date
      hour: $hour
      salesAmount: $salesAmount
      salesCount: $salesCount
      dailyTarget: $dailyTarget
    )
  }
`;
